export const DEFINITIONS_ID = {
    GREEN: '4a63f6a407f611ed8bf4fa163e89e3c8', // #A7D17E พื้นที่สีเขียว
    YELLOW: '5fead50b07f611ed8bf4fa163e89e3c8', //#FFD15C พื้นที่สีเหลือง
    ORANGE: '749e117407f611ed8bf4fa163e89e3c8', //#EA8A54 พื้นที่สีส้ม
    RED: 'a64aa37007f611ed8bf4fa163e89e3c8', //#CD5D4A พื้นที่สีแดง
    CRIMSON: 'b5c52f8307f611ed8bf4fa163e89e3c8', //#A3402F พื้นที่สีแดงเข้ม
};
